export default {
    product: {
        description: {
            more: "meer"
        },
        added: "Toegevoegd aan winkelwagen"
    }
}